import { render, staticRenderFns } from "./ActionRS.vue?vue&type=template&id=f1c0f65c&scoped=true&"
import script from "./ActionRS.vue?vue&type=script&lang=js&"
export * from "./ActionRS.vue?vue&type=script&lang=js&"
import style0 from "./ActionRS.vue?vue&type=style&index=0&id=f1c0f65c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c0f65c",
  null
  
)

export default component.exports